// extracted by mini-css-extract-plugin
export default {"accountsList":"WSAccountsList_accountsList__ElgsK","account":"WSAccountsList_account__cj3c7","accountsGroupHeader":"WSAccountsList_accountsGroupHeader__3n41s"};